import React from 'react';
import { Box, TextButton, Divider } from '@wix/design-system';
import type { Subcategory } from '@wix/app-market-components';
import { BackButton } from '../../../components/back-button';

interface SubCategoriesProps {
  subCategories: Subcategory[];
  onTagClick(categorySlug: string, subCategory: string): void;
  onBack?(): void;
}

export function SubCategories({
  subCategories,
  onTagClick,
  onBack,
}: SubCategoriesProps) {
  return (
    <Box dataHook="sub-categories-tags" marginTop="18px">
      {onBack && (
        <Box>
          <BackButton onBack={onBack} size="tiny" weight="thin" skin="dark" />
        </Box>
      )}
      {subCategories.length > 0 && (
        <>
          {onBack && (
            <Box margin="0px 12px 0px 12px">
              <Divider direction="vertical" />
            </Box>
          )}
          <Box verticalAlign="middle" align="center" gap="6px">
            {subCategories?.map((subcategory) => (
              <TextButton
                onClick={() =>
                  onTagClick(subcategory.parentSlug, subcategory.slug)
                }
                dataHook={`tag-${subcategory.id}`}
                id={subcategory.slug}
                theme="lightOutlined"
                removable={false}
                size="tiny"
                weight="normal"
                key={subcategory.slug}
              >
                {subcategory.name.toLocaleUpperCase()}
              </TextButton>
            ))}
          </Box>
        </>
      )}
    </Box>
  );
}
